import { useEffect, useRef } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Connexion WebSocket temps réel : reçoit des signaux légers du backend
// (rides_updated / position_updated) et appelle onEvent pour recharger via REST.
export function useLiveSync(onEvent) {
  const cb = useRef(onEvent);
  cb.current = onEvent;

  useEffect(() => {
    if (!BACKEND_URL) return;
    const wsUrl = BACKEND_URL.replace(/^http/, "ws") + "/api/ws";
    let socket;
    let retryTimer;
    let alive = true;

    const connect = () => {
      if (!alive) return;
      try {
        socket = new WebSocket(wsUrl);
      } catch {
        retryTimer = setTimeout(connect, 4000);
        return;
      }
      socket.onmessage = (e) => {
        try { cb.current?.(JSON.parse(e.data)); } catch (err) { console.error("WS message invalide", err); }
      };
      socket.onopen = () => { if (!alive) { try { socket.close(); } catch (err) { console.error(err); } } };
      socket.onclose = () => { if (alive) retryTimer = setTimeout(connect, 4000); };
      socket.onerror = () => { try { socket.close(); } catch (err) { console.error(err); } };
    };

    connect();
    return () => {
      alive = false;
      clearTimeout(retryTimer);
      try { if (socket && socket.readyState === WebSocket.OPEN) socket.close(); } catch (err) { console.error(err); }
    };
  }, []);
}
